export function formatAnalyticsIndex(index: number) {
  return index === -1 ? 'unknown' : index + 1
}
